const round = (value, decimals) => {
  const factor = 10 ** decimals
  return Math.round(value * factor) / factor
}

const UNIT_LABEL = {
  varyingProbability: 'exp probability',
  probability: 'avr probability',
  raw: 'raw coeff.'
}

export const buildHcAnswers = ({ answer, viewMode, chartMode }) => {
  const hcAnswers = { total: answer?.total || 0 }
  let min = 0
  let max = 0

  for (const bk of Object.keys(answer || {})) {
    if (bk[0] !== 'b' || Number.isNaN(Number(bk.slice(1)))) continue

    const newK = `a${bk.slice(1)}`
    const bv = answer[bk]
    const entry = { percents: 0, unitLabel: UNIT_LABEL[viewMode] }

    // the two probability measures are percentages, left as delivered for the precision to round
    if (viewMode === 'varyingProbability') {
      entry.amount = bv.varyingProbability
    } else if (viewMode === 'probability') {
      entry.amount = bv.probability
    } else if (viewMode === 'raw') {
      min = Math.min(min, bv.raw)
      max = Math.max(max, bv.raw)
      entry.amount = round(bv.raw, 2)

      if (['respondents', 'brespondents'].includes(chartMode) && bv.errLO && bv.errHI) {
        entry.errLO = bv.errLO
        entry.errHI = bv.errHI
        entry.sd = bv.sd
        entry.mu = bv.raw
      }
    }

    hcAnswers[newK] = entry
  }

  let yAxisLimits = false

  if (['varyingProbability', 'probability'].includes(viewMode)) {
    yAxisLimits = [0, 100]
  } else {
    const lo = min < 0 ? -Math.ceil(Math.abs(min)) : 0
    const hi = max <= 0 && lo >= 0 ? 100 : max <= 0 ? Math.ceil(Math.abs(min)) : Math.ceil(max)
    if (lo !== hi) yAxisLimits = [round(lo, 2), round(hi, 2)]
  }

  return { hcAnswers, yAxisLimits }
}
